import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import MachineFuelTanksApi from '@/services/apiServiceModules/machineFuelTanksApi'
const machineFuelTanksApi = new MachineFuelTanksApi()

const MODULE_NAME = ModulesMap.MACHINE_FUEL_TANKS

export default class MachineFuelTanksDt extends DataTransferModule {
	constructor() {
		super(MODULE_NAME, machineFuelTanksApi, {
			hasParentEntity: true,
		})
	}
}
